module.exports = __webpack_public_path__ + "img/About_Employers_DARK-03.a1bca38.svg";